module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 text-left logo"
  }, [_vm._v("\n        Money Management Application\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 account text-right"
  }, [_c('span', [_vm._v("test@test.com")]), _vm._v(" "), _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": require("../assets/img/ava.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Log out")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6408fd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Headline.vue
// module id = 712
// module chunks = 0